export default __webpack_public_path__ + "media/images/backgrounds/bg-8-5e6362947fa3be501edfd21778dca23c.jpg";